import { render, staticRenderFns } from "./SalarieTaxFreeCRUD.vue?vue&type=template&id=b523cbf4"
import script from "./SalarieTaxFreeCRUD.vue?vue&type=script&lang=js"
export * from "./SalarieTaxFreeCRUD.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports